import React from 'react'
import Header from '../component/Header'
import Donate from '../component/Donate'
import BottomBar from '../component/BottomBar'
import { Helmet } from 'react-helmet-async'

function News() {
  return (
    <>
       <Helmet>
            <title>News | The Lord Nations Foundation</title>
            <meta name="description" content="Stay updated with the latest news, events, and impact stories from The Lord Nations Foundation. Learn how we're making a difference in communities worldwide." />
        </Helmet>

        <div className='home' >
            <Header/>
            <div className='about_head_spacer'></div>
            <div className='news_banner' >
                <div className='homebanner_overlay'>
                    <div className='homebanner_container'>
                        <div className='homebanner_text' >
                            <div className='donatenow_banner_label' >
                                <h3>News</h3>
                            </div>
                        </div>

                        <div className='danate_desk'>
                            <Donate/>
                        </div>
                    </div>
                </div>
            </div>

            <div className='danate_mob'>
            <Donate/>
            </div>
            
            
            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h1>A New Hope for the less privilege</h1>
                </div>

                <div className='learn_bars'  style={{border:'none'}} >
                    <div className='learn_bars_img4'></div>
                    <div className='learn_bars_write_ups' >
                        <h1>Success Stories: The Journey Begins</h1>
                        <p>
                        We are thrilled to officially introduce The Lord Nations Foundation, a non-profit organization dedicated to providing education for underprivileged children, eradicating hunger, supporting homeless individuals. Our journey begins with a simple but powerful mission: <span style={{color:'#ee1f10', fontSize:'18px', textTransform:'capitalize', fontWeight:'800', fontFamily:'"Oswald", serif'}} >to create lasting change and bring hope to those in need.</span>
                        </p>
                        <p>
                            The idea for The Lord Nations Foundation was born out of a deep understanding of the struggles faced by many in our communities. Whether it’s children who lack access to quality education, families who go to bed hungry, or individuals without a safe place to call home, we knew something had to be done. We believe that every person deserves a chance to thrive, and our foundation exists to provide that opportunity.
                        </p>
                    </div>
                </div>

                <p>
                    Our team consists of passionate individuals—volunteers, donors, and community leaders—who share the vision of a world where no one is left behind. We are committed to making a tangible impact, not just through temporary relief, but by implementing sustainable solutions that empower people to rebuild their lives.
                </p>

                <h1 style={{width:'100%'}} >Our Mission & Vision</h1>

                <p>
                    At The Lord Nations Foundation, we are driven by a core belief: small acts of kindness can create a ripple effect of transformation and every person, regardless of their background or circumstances, deserves a fair chance at a better life. We exist to bridge the gap between struggle and opportunity, offering support, resources, and hope to those who need it the most.
                </p>

                <h2 style={{width:'100%'}}>Our Mission: </h2>
                <p>
                    Our commitment is to provide quality education to underprivileged children, offer meals to families in need, support housing solutions for the homeless, empower marginalized communities. We don’t just aim to provide short-term relief; we strive for long-term impact by creating programs and initiatives that empower individuals to break free from cycles of poverty, hardship, and despair.
                </p>

                <h3 style={{width:'100%'}}>The Driving Force Behind Our Mission</h3>
                <p
                    >We recognize that hunger, lack of education, homelessness, healthcare inequality is not just a temporary problem—it’s a deep-rooted challenge that requires sustainable and community-driven solutions. The numbers paint a stark reality:

                    📌Over 250 million children worldwide lack access to proper education and 1 in 9 people go to bed hungry every night.

                    But statistics alone don’t tell the full story. Behind every number is a real person—a child who dreams of going to school, a mother who struggles to feed her family, a young adult who yearns for a brighter future but lacks the resources to make it happen. That is why we are here: to bring real change to real lives.
                </p>

                <h2 style={{width:'100%'}}>Our Vision: </h2>
                <p>
                    Our vision extends beyond offering short-term relief. We aspire to create lasting, systemic change, ensuring that basic human rights such as education, healthcare, shelter, and economic opportunity are not privileges but fundamental rights accessible to all.
                </p>

                <h3 style={{width:'100%'}}>A Future Without Barriers</h3>
                <p>
                    We recognize that the world is filled with inequalities that prevent millions of people from achieving their dreams. Poverty, lack of access to education, healthcare disparities, and systemic social challenges create barriers that hold people back. But we also believe that these barriers can be broken—with collective effort, compassion, and strategic action.
                </p>
            </div>

            <BottomBar/>
        </div>
    </>
  )
}

export default News